export default __webpack_public_path__ + "media/flags/er-bbb6f885.svg";